// extracted by mini-css-extract-plugin
module.exports = {"container":"DogDetail_container__717Ul"};